import { render, staticRenderFns } from "./zuowenbook.vue?vue&type=template&id=1038399e&scoped=true&"
import script from "./zuowenbook.vue?vue&type=script&lang=js&"
export * from "./zuowenbook.vue?vue&type=script&lang=js&"
import style0 from "./zuowenbook.vue?vue&type=style&index=0&id=1038399e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1038399e",
  null
  
)

export default component.exports